import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#D99F9C';

export const CastDatabaseOptimization = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';

  return (
    <IconBase ref={ref} {...props} viewBox="0 0 25 27" fill="none">
      <path
        d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6273 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58206 5.59279C0.604212 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602225 20.8428 1.58206 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
        fill={fill}
      />
      <path
        d="M18.8916 17.5232C18.8916 19.7452 15.8567 21.5459 12.1142 21.5459C8.3718 21.5459 5.33691 19.7452 5.33691 17.5232"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.8916 13.5004C18.8916 15.7224 15.8567 17.523 12.1142 17.523C8.3718 17.523 5.33691 15.7224 5.33691 13.5004"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.8916 9.47556C18.8916 11.6976 15.8567 13.4982 12.1142 13.4982C8.3718 13.4982 5.33691 11.6976 5.33691 9.47556C5.33691 7.25355 8.3718 5.45288 12.1142 5.45288C15.2942 5.45288 17.9634 6.75469 18.6948 8.50765C18.824 8.8177 18.8916 9.14166 18.8916 9.47556Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M18.8911 17.5232V9.47583"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M5.33887 17.5232V9.47583"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M20.9858 13.5011H24.2294"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M3.2416 13.5011H0"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </IconBase>
  );
};

CastDatabaseOptimization.displayName = 'CastDatabaseOptimization';
